export class MotivosEstadoSubmetido {
  public codMotivo?: string;
  public description?: string;
  public descriptionEn?: string;
  public descriptionDe?: string;
  public showObs?: boolean;
  public visibel?: boolean;
}
